<script>
export default {
    name: "InventoryTransactionApproval",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
        };
    },

    components: {

        "tranfer-items-tab": () => import(`./approvals/StockTranfer.vue`),
        // "stock-reset-tab": () => import('./approvals/StockReset.vue'),
        "stock-journal-tab": () => import('./approvals/StockJournal.vue'),
        "stock-take-tab": () => import('./approvals/StockTake.vue'),
        // "expired-stock-tab": () => import('./approvals/ExpiredStock.vue'),
    },

}
</script>
<template>
    <tail-base-layout>
        <template v-slot:content>
            <tail-card>
                <template v-slot:card-header>
                    <h5 class="text-sm font-medium">Inventory: Transaction Approvals</h5>
                </template>
                <template v-slot:card-body>
                    <ul class="flex w-full">
                      <li class="-mb-px mr-1">
                            <a @click.prevent="active=0" 
                                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                                :class="active == 0 ? activeClass : inActiveClass" href="#">Approve Transfered Items</a>
                      </li>
                      <!-- <li class="-mb-px mr-1">
                        <a @click.prevent="active=1" 
                            class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                            :class="active == 1 ? activeClass : inActiveClass" href="#">Approve Stock Reset</a>
                      </li> -->
                      <li class="-mb-px mr-1">
                        <a @click.prevent="active=2" 
                           class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                           :class="active == 2 ? activeClass : inActiveClass" href="#">Approve Stock Journals</a>
                      </li>
                      <li class="-mb-px mr-1">
                        <a @click.prevent="active=3" 
                            class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                            :class="active == 3 ? activeClass : inActiveClass" href="#">Approve Stock Take</a>
                      </li>
                      <!-- <li class="-mb-px mr-1">
                        <a @click.prevent="active=4" 
                            class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                            :class="active == 4 ? activeClass : inActiveClass" href="#">Approve Expired Stock</a>
                      </li> -->
                    </ul>
                    <div class="w-full" v-if="active==0">
                        <tranfer-items-tab/>
                    </div>
                    <!-- <div class="w-full" v-if="active==1">
                        <stock-reset-tab/>
                    </div> -->
                    <div class="w-full" v-if="active==2">
                        <stock-journal-tab/>
                    </div>
                    <div class="w-full" v-if="active==3">
                        <stock-take-tab/>
                    </div>
                    <!-- <div class="w-full" v-if="active==4">
                        <expired-stock-tab/>
                    </div> -->
                </template>
                <template v-slot:card-footer>
                   <div class="w-full text-right">
                     <router-link :to="{ name: `inventory-management.index` }" class="btn-sm btn-danger text-xs rounded"><i class="fa fa-caret-left"></i> Back</router-link>
                   </div>
                </template>
            </tail-card>
        </template>
    </tail-base-layout>
</template>
